import { getApiInstance } from '../helpers';

const postWorkdeskUnassignTickets = (ticketIds: string[]) => {
  return getApiInstance()
    .post('/ticket/unassign', {
      ticketIds,
    })
    .then((res) => {
      return res.data;
    });
};
export const unassignTicketsService = {
  postWorkdeskUnassignTickets,
};
